// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jnL8","rootMobile":"styles_rootMobile__2x20P"};